import SearchFilters from "../../components/Search/SearchWithAdvanced";
import Layout from "../../components/Layouts/WithAuth/Layout";
import ScreenHeader from "../../components/Headers/ScreenHeader";

const SearchScreenV2 = () => {
  return (
    <Layout pageTitle={"FirmConnector :: Search"}>
      <ScreenHeader
        title={"Search"}
        subText={
          "Browse and match candidates using keywords, filters, and smart insights"
        }
      />
      <SearchFilters />
    </Layout>
  );
};

export default SearchScreenV2;
